<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("services") }}
      </h1>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("date range") }}</label>
          <generic-calendar
            type="date"
            :is_range="true"
            ref="generic_calendar"
            @selected="date_changed"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('service type')"
            :placeholder="$t('select service type')"
            url="/mechanix/service-type/catalog"
            :is_multiple="true"
            name_field="name"
            value_field="type_id"
            @selected="set_type"
          />
        </div>
        <div class="field">
          <label class="label">{{ $t("query") }}</label>
          <div class="control">
            <button class="button is-rounded is-primary" @click="query">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("query") }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="title is-5 is-pulled-right" v-if="total">
      {{ $t("total") }}: {{ format_currency(total) }}
    </div>

    <div class="title is-6">{{ $t("services") }}</div>
    <table class="table is-fullwidth is-striped is-hoverable">
      <thead>
        <tr>
          <th>{{ $t("date") }}</th>
          <th>{{ $t("customer") }}</th>
          <th>{{ $t("vehicle") }}</th>
          <th>{{ $t("service type") }}</th>
          <th>{{ $t("total") }}</th>
          <!-- <th>{{ $t("total") }}</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="(service, oidx) in services" :key="oidx">
          <td>
            <i
              class="icon"
              v-if="service.settings && service.settings.finalize"
            >
              <i class="fa fa-check has-text-success"></i>
            </i>
            <i class="icon" v-else>
              <i class="fa fa-clock-o has-text-warning"></i>
            </i>
            {{ format_date(service.create_date) }}
          </td>
          <td>{{ service.customer }}</td>
          <td>{{ service.brand }}</td>
          <td>{{ service.type ? service.type.name : "" }}</td>
          <td>
            <div v-if="service.settings && service.settings.finalize">
              {{ format_currency(service.settings.finalize.final_amount) }}
            </div>
          </td>
          <!-- <td>
            <pre>{{ service }}</pre>
          </td> -->
          <!-- <td>{{ order.name }}</td>
          <td>
            <ul
              v-if="
                order.tailoring_order_items &&
                order.tailoring_order_items.length
              "
            >
              <li
                v-for="(item, iidx) in order.tailoring_order_items"
                :key="iidx"
              >
                {{ item.quantity }} x {{ item.product.name }} @
                {{ format_currency(item.price) }}
              </li>
            </ul>
          </td>
          <td>
            {{ order.validation_result.reason }}
          </td> -->
        </tr>
      </tbody>
    </table>
    <!-- <pre>{{ orders }}</pre> -->
  </section>
</template>

<script>
import {
  get,
  generate_datatables_buttons,
  error_message,
  put,
  post,
  del,
  confirm_deletion_dialog,
  success_message,
  format_date_time,
  format_date,
  format_time,
  format_currency,
  change_active_tab,
} from "@/utils";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { groupBy } from "lodash";

export default {
  name: "SalesReport",
  components: { GenericTable, GenericCalendar, GenericDropdown },
  data() {
    let v = this;
    return {
      meta: {
        start_date: "",
        end_date: "",
      },
      services: [],
    };
  },
  computed: {
    total() {
      let v = this;
      return v.services.reduce((acc, service) => {
        if (service.settings && service.settings.finalize)
          return acc + Number(service.settings.finalize.final_amount);
        return acc;
      }, 0);
    },
  },
  methods: {
    format_date_time,
    format_time,
    format_date,
    format_currency,
    query() {
      let v = this;
      let data = {
        args: v.meta,
        report_uuid: v.$route.params.id,
        method: "qq",
      };
      post("/report/query", data)
        .then((r) => {
          v.services = r;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    date_changed(date) {
      let v = this;
      v.meta.start_date = date.start_date;
      v.meta.end_date = date.end_date;
    },
    set_type(types) {
      let v = this;
      if (types) {
        if (Array.isArray(types))
          v.meta.service_types = types.map((p) => p.type_id);
        else v.meta.service_types = [types.type_id];
      }
    },
  },
  mounted() {
    let v = this;

    // get("/apis/system/users", {})
    //   .then((r) => {
    //     v.users = r;

    //     setTimeout(() => {
    //       // // To access to bulmaCalendar instance of an element
    //       // var element = document.querySelector("#my-element");
    //       // if (element) {
    //       //   // bulmaCalendar instance is available as element.bulmaCalendar
    //       //   element.bulmaCalendar.on("select", function (datepicker) {
    //       //     console.log(datepicker.data.value());
    //       //   });
    //       // }
    //     }, 200);
    //   })
    //   .catch((error) => {
    //     error_message(error);
    //   });
  },
};
</script>

<style>
/* Add Bulma styles here */
</style>
